import { render, staticRenderFns } from "./FollowerFormPhone.vue?vue&type=template&id=fed5b244&scoped=true&"
import script from "./FollowerFormPhone.vue?vue&type=script&lang=js&"
export * from "./FollowerFormPhone.vue?vue&type=script&lang=js&"
import style0 from "./FollowerFormPhone.vue?vue&type=style&index=0&id=fed5b244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed5b244",
  null
  
)

export default component.exports